import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const downloadReportFileReq = (
  requestId: string,
  transactionType: string,
  mid: string,
  tokens: any,
  isSmid: boolean,
  filename: string,
) => {
  console.log('Report ~ filename:', filename)
  const reqBody = {
    inputFilter: {
      transactionType: transactionType,
      merchantId: mid,
      requestId: requestId,
      isSMID: isSmid ? 'Y' : 'N',
    },
    // outputDomains: undefined,
  }
  const apiPath =
    transactionType !== 'SETTLEMENT' ? APIEndPoints.getTxnsRefundsDownloadFile : APIEndPoints.getSettlementsDownloadFile

  return fetch(`${sitConfig(tokens).baseUrl}${apiPath}`, {
    method: 'POST',
    headers: sitConfig(tokens).headers,
    body: JSON.stringify(reqBody),
  })
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { downloadReportFileReq }
